import { createSlice } from "@reduxjs/toolkit";

const initialState = null;

const { actions, reducer } = createSlice({
  name: "root",
  initialState,
  reducers: {
    clearAuthData() {
      return initialState;
    },
    clearPbxData() {
      return initialState;
    },
  },
});

export const { clearAuthData, clearPbxData } = actions;

export default reducer;
